// extracted by mini-css-extract-plugin
module.exports = {"teamsDropdown":"TeamsGroupsSelect_teamsDropdown__iHSBH","hidden":"TeamsGroupsSelect_hidden__3iv7u"};